import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  Optional,
  ViewChild,
  inject
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ParentItemProviderService } from '@app/shared';
import {
  log,
  UIComponents,
  ListViewProviderDirective,
  ListView,
  ViewWindow,
  DataSource
} from '@ntap/core';
import {
  Observable,
  Subject,
  first,
  map,
  switchMap,
  takeUntil,
  tap
} from 'rxjs';
import { FIZICKI_OBJEKT_PARENT_ITEM } from '../pojavni-oblik/pojavni-oblik.component';

@Component({
  selector: 'app-razmjesti-nize',
  templateUrl: './razmjesti-nize.component.html',
  styleUrls: ['./razmjesti-nize.component.scss'],
  providers: [ParentItemProviderService]
})
export class RazmjestiNizeComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  listViewProvider = inject(ListViewProviderDirective);
  itemViewProvider = inject(FIZICKI_OBJEKT_PARENT_ITEM);
  disabled$: Observable<boolean>;

  INIT_COMP_ID = UIComponents.LISTVIEW;

  currentListViewName: string;
  currentListViewState: object;
  currentListViewStateFilter: object = {};

  @ViewChild(ListViewProviderDirective<ListView>)
  listaJedinicaUKojuRazmjestamo: ListViewProviderDirective<ListView>;
  private destroy = new Subject<boolean>();

  constructor(
    protected route: ActivatedRoute,
    protected parentItemProvider: ParentItemProviderService,
    protected dataSource: DataSource,
    @Optional() protected window: ViewWindow
  ) {}

  ngAfterViewInit(): void {
    this.disabled$ = this.listaJedinicaUKojuRazmjestamo.selectedItems$.pipe(
      takeUntil(this.destroy),
      map((selected: string | any[]) => selected.length === 0)
    );
  }

  ngOnInit() {
    this.currentListViewState = {};
    this.itemViewProvider.item$
      .pipe(takeUntil(this.destroy))
      .subscribe((parentItem) => {
        log('param change');
        this.changeView('razmjesti_nize_list', parentItem);
      });
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
  }

  changeView(viewName: string, parentItem: any) {
    log(`CHANGE NEW view: ${viewName}`);
    this.currentListViewName = viewName;

    this.listViewProvider.selectedItems$
      .pipe(
        first(), // Dohvati prvu vrijednost iz selectedItems$
        tap((selectedItems) => {
          this.currentListViewState = {
            $parent: parentItem,
            $selected: selectedItems,
            $itemType: 'en~jedinica_gradiva',
            $parentType: 'en~jedinica_gradiva'
          };
        })
      )
      .subscribe();
    this.currentListViewStateFilter = {};
  }

  razmjestiFizickeObjekte() {
    this.listViewProvider.selectedItems$
      .pipe(
        first(),
        switchMap((fizickiObjektiOdabraniZaRazmjestanje) => {
          return this.listaJedinicaUKojuRazmjestamo.selectedItems$.pipe(
            switchMap((listaJedinicaUKojuRazmjestamo) => {
              const actionParams = {
                $selected: fizickiObjektiOdabraniZaRazmjestanje,
                $jediniceUKojuTrebaPremjestiti: listaJedinicaUKojuRazmjestamo
              };
              return this.listViewProvider.executeAction(
                'potvrdiRazmjestanjeFizickihObjekata',
                actionParams
              );
            })
          );
        }),
        tap(() => {
          this.listViewProvider.refresh();
          this.window.close();
        })
      )
      .subscribe();
  }
}
